import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {RootCloseWrapper} from "react-overlays";

class FilterDropdown extends Component {
    static propTypes = {
        open: PropTypes.bool,
        pullRight: PropTypes.bool,
        onClose: PropTypes.func,
        labelledBy: PropTypes.oneOfType([
            PropTypes.string, PropTypes.number,
        ]),
        onSelect: PropTypes.func,
        rootCloseEvent: PropTypes.oneOf(['click', 'mousedown']),
    };
    static defaultProps = {
        bsRole: 'menu',
        pullRight: false,
    };
    state = {};

    handleRootClose(event) {
        this.props.onClose(event, { source: 'rootClose' });
    }

    render() {
        const {
            open,
            pullRight,
            rootCloseEvent,
            children,
            ...props
        } = this.props;

        return (
            <RootCloseWrapper
                disabled={!open}
                onRootClose={event => this.handleRootClose(event)}
                event={rootCloseEvent}>
                {children}
            </RootCloseWrapper>
        );
    }
}

export default FilterDropdown;


// WEBPACK FOOTER //
// ./src/datagrid/FilterDropdown.js